import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import GeneralStatisticsTab from './tabs/GeneralStatisticsTab';
import GanttTab from './tabs/GanttTab';
import { useScrollStableHeight } from '../../hooks/useScrollStableHeight';
import { useNavigationEntitlements } from '../../hooks/useNavigationEntitlements';
import { isNavigationKeyAllowed } from '../../utils/navigationEntitlements';
import './StatisticsPage.css';

// navKey — ключ «Видимых вкладок» (Роли): снятая там вкладка здесь скрыта.
const TABS = [
  { id: 'general', label: 'Общая статистика', navKey: 'analytics.statistics' },
  { id: 'gantt', label: 'Диаграмма Ганта', navKey: 'analytics.gantt' },
];

export default function StatisticsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const stableRef = useScrollStableHeight();

  const { keys: navigationKeys } = useNavigationEntitlements();
  const shownTabs = useMemo(() => {
    const visible = TABS.filter((tab) => isNavigationKeyAllowed(navigationKeys, tab.navKey));
    return visible.length > 0 ? visible : TABS;
  }, [navigationKeys]);

  const requestedTab = searchParams.get('tab');

  const activeTab = useMemo(() => {
    const requested = requestedTab || 'general';
    return shownTabs.some((tab) => tab.id === requested) ? requested : shownTabs[0].id;
  }, [requestedTab, shownTabs]);

  const handleTabClick = (tabId) => {
    const params = new URLSearchParams(searchParams);

    if (tabId === 'general') {
      params.delete('tab');
    } else {
      params.set('tab', tabId);
    }

    setSearchParams(params);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'general':
        return <GeneralStatisticsTab />;
      case 'gantt':
        return (
          <div className="sp-tab-content sp-tab-content--gantt">
            <GanttTab />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="sp-container">
      <h1>Статистика</h1>

      <div className="sp-tabs">
        {shownTabs.map((tab) => (
          <button
            key={tab.id}
            className={`sp-tab-btn${activeTab === tab.id ? ' sp-tab-btn--active' : ''}`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Высота удерживается до низа экрана: пересборка блоков под фильтром
          не должна дёргать прокрутку. */}
      <div ref={stableRef} className="sp-stable">
        {renderContent()}
      </div>
    </div>
  );
}